import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle, withState, withHandlers } from 'recompose'

import {
  onComponentDidMount,
  handlers,
  childHandlers,
  mapStateToProps,
  onComponentDidUpdate,
} from './Events'

const Intercom = () => null

const enhancer = compose(
  withRouter,
  connect(mapStateToProps),
  withState('trackedFiles', 'setTrackedFiles', []),
  withHandlers({
    trackEvent: () => (name, fields) => global.Intercom('trackEvent', name, fields),
  }),
  withHandlers(handlers()),
  withHandlers(childHandlers()),
  lifecycle({
    componentDidMount() {
      onComponentDidMount(this.props)
    },
    componentDidUpdate(prevProps) {
      onComponentDidUpdate(prevProps, this.props)
    },
  }),
)

export default enhancer(Intercom)
